const types = {
    zonesGet:'Zonas - Get',
    zonesCreate: 'Zonas - Create',
    zonesUpdate: 'Zonas - Update',
    zonesDelete: 'Zonas - Delete',
    renderInfo: 'Zonas - Status',
    renderStock: 'Stock - Status',
    renderClientes: 'Clientes - Status',
    clientsGet: 'Clientes - Get',
    clientsCreate: 'Clientes - Create',
    clientsUpdate: 'Clientes - Update',
    clientsDelete: 'Clientes - Delete',
    clientsUpdateZona : 'Clientes Zonas - Update',
    serviceCreate: 'Servicios - Create',
    serviceUpdate: 'Servicios - Update',
    serviceDelete: 'Servicios - Delete',
    stockGet:'Stock - Get',
    stockCreate:'Stock - Create',
    stockUpdate:'Stock - Update',
    stockDelete:'Stock - Delete',  
    otGet:'Ot - Get',
    otCreate:'Ot - Create',
    otUpdate:'Ot - Update',
    otDelete:'Ot - Delete',   
    renderOts:'Ot - Status',
    adicionalGet:'Adicional - Get',
    adicionalCreate:'Adicional - Create',
    adicionalUpdate:'Adicional - Update',
    adicionalDelete:'Adicional - Delete',   
    renderAdicionales:'Adicional - Status',
    descuentoGet:'Descuento - Get',
    descuentoCreate:'Descuento - Create',
    descuentoUpdate:'Descuento - Update',
    descuentoDelete:'Descuento - Delete',   
    renderDescuentos:'Descuento - Status',
    recibosGet:'Recibos - Get',
    recibosCreate:'Recibos - Create',
    recibosUpdate:'Recibos - Update',
    recibosDelete:'Recibos - Delete',   
    renderRecibos:'Recibos - Status',
    facturasGet:'Facturas - Get',
    facturasCreate:'Facturas - Create',
    facturasUpdate:'Facturas - Update',
    facturasDelete:'Facturas - Delete',   
    renderFacturas:'Facturas - Status',
    statusSocket: 'Estado - Socket'  
};

const initialStore = {
    zonas: [],
    clientes: [],
    stock:[],
    ots:[],
    adicionales:[],
    descuentos:[],
    recibos:[],
    facturas:[],
    isReadyInfo:false,
    isReadyStock:false,
    isReadyClientes:false,
    isReadyOts:false,
    isReadyAdicionales:false,
    isReadyDescuentos:false,
    isReadyRecibos:false,
    isReadyFacturas:false,
    isSocket:false
}

const storeReducer = (state, action)=>{
    switch(action.type){
        case types.statusSocket:
            return{
                ...state,
                isSocket: action.payload
            }
        case types.zonesGet:
            return{
                ...state,
                zonas: action.payload
            }
        case types.clientsGet:
            return{
                ...state,
                clientes: action.payload
            }
        case types.clientsCreate:
            const arrCli_0 = [...state.clientes];
            arrCli_0.push(action.payload);
            return{
                ...state,
                clientes: arrCli_0
            } 
        case types.clientsUpdate:
            const arrCli_1 = [...state.clientes];
            const arfCli_1 = arrCli_1.map(el=>el._id === action.payload._id ? action.payload : el)
            return{
                ...state,
                clientes: arfCli_1
            }
        case types.clientsUpdateZona:
            const arrCli_1Z = [...state.clientes];
            const arfCli_1Z = arrCli_1Z.map(el=>{
                if(el._id === action.payload.idCliente){
                    const objetoZonaCliente = {...el};
                    objetoZonaCliente.Zonas = action.payload.Zonas;
                    return objetoZonaCliente;
                }else{
                    return el;
                }
            });
            return{
                ...state,
                clientes: arfCli_1Z
            }
        case types.clientsDelete:
            const arrCli_2 = [...state.clientes];
            const arfCli_2 = arrCli_2.filter(el=>el._id !== action.payload._id)
            return{
                ...state,
                clientes: arfCli_2
            }
        case types.serviceCreate:
            const arrCli_1_ = [...state.clientes];
            const arfCli_1_ = arrCli_1_.filter(el=> el._id === action.payload.idCliente);
            const arfCli_12 = [...arfCli_1_[0].Servicios];
            arfCli_12.push(action.payload.Servicio);
            const objeto = {...arfCli_1_[0]};
                objeto.Servicios = [...arfCli_12];
            const arfCli_13 = arrCli_1_.map(el=>el._id === action.payload.idCliente ? objeto : el)   
            return{
                ...state,
                clientes: arfCli_13
            }
        case types.serviceUpdate:
            const arrCli_2_ = [...state.clientes];
            const arfCli_2_ = arrCli_2_.filter(el=> el._id === action.payload.idCliente);
            const arfCli_22 = arfCli_2_[0].Servicios.map(el=> el._id === action.payload.Servicio._id ? action.payload.Servicio : el);
            const objeto2 = {...arfCli_2_[0]};
                objeto2.Servicios = [...arfCli_22];
            const arfCli_23 = arrCli_2_.map(el=>el._id === action.payload.idCliente ? objeto2 : el)   
            return{
                ...state,
                clientes: arfCli_23
            }
        case types.serviceDelete:
            const arrCli_3_ = [...state.clientes];
            const arfCli_3_ = arrCli_3_.filter(el=> el._id === action.payload.idCliente);
            const arfCli_32 = arfCli_3_[0].Servicios.filter(el=> el._id !== action.payload.Servicio._id);
            const objeto3 = {...arfCli_3_[0]};
                objeto3.Servicios = [...arfCli_32];
            const arfCli_33 = arrCli_3_.map(el=>el._id === action.payload.idCliente ? objeto3 : el)   
            return{
                ...state,
                clientes: arfCli_33
            }
        case types.stockGet:
            return{
                ...state,
                stock: action.payload,
            }
        case types.stockCreate:
            const arrStock_0 = [...state.stock];
            arrStock_0.unshift(action.payload);
            return{
                ...state,
                stock: arrStock_0,
            }
        case types.stockUpdate:
            const arrStock_1 = [...state.stock];
            const arrfStock_1 = arrStock_1.map(el=>el._id === action.payload._id ? action.payload : el)
            return{
                ...state,
                stock: arrfStock_1,
            }
        case types.stockDelete:
            const arrStock_2 = [...state.stock];
            const arrfStock_2 = arrStock_2.filter(el=>el._id !== action.payload._id)
            return{
                ...state,
                stock: arrfStock_2,
            }
        case types.renderInfo:
            return{
                ...state,
                isReadyInfo: action.payload
            }
        case types.renderClientes:
            return{
                ...state,
                isReadyClientes: action.payload
            }
        case types.renderStock:
            return{
                ...state,
                isReadyStock: action.payload
            }
        case types.otGet:
            return{
                ...state,
                ots: action.payload,
            }
        case types.otCreate:
            const arrOt_0 = [...state.ots];
            arrOt_0.unshift(action.payload);
            return{
                ...state,
                ots: arrOt_0,
            }
        case types.otUpdate:
            const arrOt_1 = [...state.ots];
            const arrfOt_1 = arrOt_1.map(el=>el._id === action.payload._id ? action.payload : el)
            return{
                ...state,
                ots: arrfOt_1,
            }
        case types.otDelete:
            const arrOt_2 = [...state.ots];
            const arrfOt_2 = arrOt_2.filter(el=>el._id !== action.payload._id)
            return{
                ...state,
                ots: arrfOt_2,
            }
        case types.renderOts:
            return{
                ...state,
                isReadyOts: action.payload
            }
        case types.adicionalGet:
            return{
                ...state,
                adicionales: action.payload,
            }
        case types.adicionalCreate:
            const arrAd_0 = [...state.adicionales];
            arrAd_0.unshift(action.payload);
            return{
                ...state,
                adicionales: arrAd_0,
            }
        case types.adicionalUpdate:
            const arrAd_1 = [...state.adicionales];
            const arrfAd_1 = arrAd_1.map(el=>el._id === action.payload._id ? action.payload : el)
            return{
                ...state,
                adicionales: arrfAd_1,
            }
        case types.adicionalDelete:
            const arrAd_2 = [...state.adicionales];
            const arrfAd_2 = arrAd_2.filter(el=>el._id !== action.payload._id)
            return{
                ...state,
                adicionales: arrfAd_2,
            }
        case types.renderAdicionales:
            return{
                ...state,
                isReadyAdicionales: action.payload
            }
        case types.descuentoGet:
            return{
                ...state,
                descuentos: action.payload,
            }
        case types.descuentoCreate:
            const arrAd_0D = [...state.descuentos];
            arrAd_0D.unshift(action.payload);
            return{
                ...state,
                descuentos: arrAd_0D,
            }
        case types.descuentoUpdate:
            const arrAd_1D = [...state.descuentos];
            const arrfAd_1D = arrAd_1D.map(el=>el._id === action.payload._id ? action.payload : el)
            return{
                ...state,
                descuentos: arrfAd_1D,
            }
        case types.descuentoDelete:
            const arrAd_2D = [...state.descuentos];
            const arrfAd_2D = arrAd_2D.filter(el=>el._id !== action.payload._id)
            return{
                ...state,
                descuentos: arrfAd_2D,
            }
        case types.renderDescuentos:
            return{
                ...state,
                isReadyDescuentos: action.payload
            }
        case types.recibosGet:
            return{
                ...state,
                recibos: action.payload,
            }
        case types.recibosCreate:
            const arrAd_0D_ = [...state.recibos];
            arrAd_0D_.unshift(action.payload);
            return{
                ...state,
                recibos: arrAd_0D_,
            }
        case types.recibosUpdate:
            const arrAd_1D_ = [...state.recibos];
            const arrfAd_1D_ = arrAd_1D_.map(el=>el._id === action.payload._id ? action.payload : el)
            return{
                ...state,
                recibos: arrfAd_1D_,
            }
        case types.recibosDelete:
            const arrAd_2D_ = [...state.recibos];
            const arrfAd_2D_ = arrAd_2D_.filter(el=>el._id !== action.payload._id)
            return{
                ...state,
                recibos: arrfAd_2D_,
            }
        case types.renderRecibos:
            return{
                ...state,
                isReadyRecibos: action.payload
            }
        case types.facturasGet:
            return{
                ...state,
                facturas: action.payload,
            }
        case types.facturasCreate:
            const arrAd_0D_0 = [...state.facturas];
            arrAd_0D_0.unshift(action.payload);
            return{
                ...state,
                facturas: arrAd_0D_0,
            }
        case types.facturasUpdate:
            const arrAd_1D_0 = [...state.facturas];
            const arrfAd_1D_0 = arrAd_1D_0.map(el=>el._id === action.payload._id ? action.payload : el)
            return{
                ...state,
                facturas: arrfAd_1D_0,
            }
        case types.facturasDelete:
            const arrAd_2D_0 = [...state.facturas];
            const arrfAd_2D_0 = arrAd_2D_0.filter(el=>el._id !== action.payload._id)
            return{
                ...state,
                facturas: arrfAd_2D_0,
            }
        case types.renderFacturas:
            return{
                ...state,
                isReadyFacturas: action.payload
            }
        default:
            return state;
    }
};

export { initialStore, types }
export default storeReducer